import { getCurrentUrl } from 'preact-router';

import { setProductsPromptModalState } from '@/components/products/ProductsPromptModal/redux/actions';
import { HabitatListItem } from '@/queries/habitats/types';
import { UserState } from '@/redux/slices/user/types';
import store from '@/redux/store';

import { loadPage, MULTI_FREE_HABITAT_COUNT } from '../../helpers';
import { goToHabitatPage } from '../habitat/helpers';
import { goToSignup } from '../home/helpers';

export const getFreeHabitatIds = ({
  habitats,
  subscription,
  loggedIn,
  isMultiFreeHabitat = false,
}: {
  habitats: HabitatListItem[];
  subscription: Pick<UserState['subscription'], 'active'>;
  loggedIn: boolean;
  isMultiFreeHabitat?: boolean;
}) => {
  const allFreeHabitats = habitats
    .filter(({ isFreemium }) => isFreemium)
    .sort((a, b) => Number(b.online) - Number(a.online) || a.freemiumPriority - b.freemiumPriority)
    .map((habitat) => habitat._id);

  if (!loggedIn) {
    const freeHabitatCount = isMultiFreeHabitat ? MULTI_FREE_HABITAT_COUNT : 1;

    return allFreeHabitats.slice(0, freeHabitatCount);
  }
  if (!subscription.active) {
    return allFreeHabitats;
  }
  return [];
};

export const getHabitatDescription = ({
  habitat,
  loggedIn,
  freeHabitatIds,
}: {
  habitat: HabitatListItem;
  loggedIn: boolean;
  freeHabitatIds: Set<string> | undefined;
}) => {
  if (loggedIn) {
    return habitat.description;
  }
  if (freeHabitatIds?.has(habitat._id)) {
    return 'zoolife features live animal streams from the worlds’ top zoos, hosted by experts. Sign up for unlimited access to this free habitat.';
  }
  return 'zoolife features live animal streams from the worlds’ top zoos, hosted by experts. Purchase a pass to explore all habitats on zoolife.';
};

export const getPrimaryButtonTitle = ({ loggedIn, isLocked }: { loggedIn: boolean; isLocked: boolean }) => {
  if (loggedIn) {
    return isLocked ? 'Unlock' : 'Visit';
  }
  return 'Buy a Pass';
};

export const onClickCardHandler = ({
  habitat,
  loggedIn,
  termsAccepted,
  openTermsModalAction,
  freeHabitatIds,
  isLocked,
}: {
  habitat: HabitatListItem;
  loggedIn: boolean;
  termsAccepted: boolean;
  openTermsModalAction: () => void;
  freeHabitatIds: Set<string> | undefined;
  isLocked: boolean;
}) => {
  if (loggedIn) {
    if (!termsAccepted) {
      openTermsModalAction();
    } else if (isLocked) {
      store.dispatch(
        setProductsPromptModalState({
          primaryProductType: 'all-habitats-day-pass',
          secondaryProductType: 'explorer-pass',
          entryPoint: 'map',
        }),
      );
    } else {
      goToHabitatPage(habitat.zoo?.slug, habitat.slug);
    }
  } else if (freeHabitatIds?.has(habitat._id)) {
    if (getCurrentUrl().includes('/album/')) {
      window.parent.location = `${window.document.location.origin}/signup?utm_source=zoolife&utm_medium=public&utm_campaign=albumpage`;
    } else {
      goToSignup();
    }
  } else {
    loadPage('/signup');
  }
};
